<template>
  <v-dialog
    v-model="getModalCadastroPesquisaSatisfacao"
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Pesquisa de Satisfação</v-card-title>
      <v-card-text>
        <v-form class="px-3 pt-3" ref="formPesquisaSatisfacao">
          <v-layout row wrap>
           <v-flex xs12 md12>
              <v-text-field
                label="Como conheceu a Amapá Piscinas?"
                v-model="getPesquisaSatisfacao.como_conheceu"
                outlined
                dense
                class="ml-2 mr-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="['SIM', 'NÃO']"
                v-model="getPesquisaSatisfacao.indicaria_servicos"
                label="Indicaria nossos serviços?"
                outlined
                dense
                class="ml-2 mr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="['SIM', 'NÃO']"
                v-model="getPesquisaSatisfacao.conhece_midias_sociais"
                label="Você conhece nossas mídias sociais?"
                outlined
                dense
                class="ml-2 mr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
             <v-text-field
               label="Qual mídia social você mais usa?"
               v-model="getPesquisaSatisfacao.midia_mais_usada"
               outlined
               dense
               class="ml-2 mr-2"
             ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                v-model="getPesquisaSatisfacao.check_list_produtos"
                :items="opcoes_check_list"
                :menu-props="{ maxHeight: '400' }"
                label="Checklist de Produtos"
                multiple
                class="ml-2 mr-2"
                outlined
                dense
                chips
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="opcoes_avaliacao"
                v-model="getPesquisaSatisfacao.avaliacao_atendimento"
                label="Avaliação Atendimento"
                outlined
                dense
                class="ml-2 mr-2"
                :rules="rules.avaliacao_atendimento"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="opcoes_avaliacao"
                v-model="getPesquisaSatisfacao.avaliacao_caixa"
                label="Avaliação Caixa"
                outlined
                dense
                class="ml-2 mr-2"
                :rules="rules.avaliacao_caixa"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="opcoes_avaliacao"
                v-model="getPesquisaSatisfacao.avaliacao_produtos"
                label="Avaliação Produtos"
                outlined
                dense
                class="ml-2 mr-2"
                :rules="rules.avaliacao_produtos"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="opcoes_avaliacao"
                v-model="getPesquisaSatisfacao.avaliacao_servicos"
                label="Avaliação Serviços"
                outlined
                dense
                class="ml-2 mr-2"
                :rules="rules.avaliacao_servicos"
              ></v-select>
            </v-flex>
           
            <v-flex xs12 md12>
              <v-file-input
                label="Anexo"
                v-if="showInputAnexo"
                @change="selecionaAnexo"
                outlined
                dense
                class="mr-2 ml-2"
                :rules="rules.anexo"
              ></v-file-input>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalCadastroPesquisaSatisfacao(false)"
          outlined
          >Voltar</v-btn
        >
        <v-btn
          color="error"
          @click="setModalExcluirPesquisaSatisfacao(true)"
          outlined
          v-if="
            getPesquisaSatisfacao.id &&
            $helper.verificaPermissao('excluir-pesquisa-satisfacao')
          "
          >Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <a
          v-if="getPesquisaSatisfacao.anexo"
          :href="getPesquisaSatisfacao.anexo"
          target="_blank"
          class="mr-2"
          ><v-btn color="primary" outlined dense>Visualizar Anexo</v-btn></a
        >
        <v-btn
          color="success"
          @click="modalConfirmacao = true"
          outlined
          v-if="
            $helper.verificaPermissao('cadastrar-pesquisa-satisfacao') ||
            $helper.verificaPermissao('atualizar-pesquisa-satisfacao')
          "
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="modalConfirmacao"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title> Confirmar </v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="modalConfirmacao = false" outlined
            >Voltar</v-btn
          >

          <v-spacer></v-spacer>
          <v-btn color="success" @click="salvar()" outlined>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalExcluir />
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/crm/pesquisaSatisfacao/ModalExcluir";
export default {
  components: {
    ModalExcluir,
  },
  data: () => ({
    opcoes_check_list: [
      "Casa de máquina limpa e vedada",
      "Sistema de filtro e bomba funcionando",
      "Piscina limpa",
      "Borda limpa",
      "Entrega de todos os acessórios",
      "Informações sobre funcionamento de filtro e bomba",
      "Cascata instalada e funcionando",
      "Teste de refletores / luzes acesas",
      "Entrega de todos os acesórios",
    ],
    opcoes_avaliacao: ["RUIM", "REGULAR", "BOM"],
    modalConfirmacao: false,
    showInputAnexo: true,
    anexo: "",
    rules: {
      avaliacao_atendimento: [(v) => !!v || "Campo obrigatório"],
      avaliacao_caixa: [(v) => !!v || "Campo obrigatório"],
      avaliacao_produtos: [(v) => !!v || "Campo obrigatório"],
      avaliacao_servicos: [(v) => !!v || "Campo obrigatório"],
      anexo: [(v) => !!v || "Campo obrigatório"],
    },
  }),
  computed: {
    ...mapGetters([
      "getModalCadastroPesquisaSatisfacao",
      "getPesquisaSatisfacao",
      "getVenda",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalCadastroPesquisaSatisfacao",
      "setModalExcluirPesquisaSatisfacao",
      "salvarPesquisaSatisfacao",
      "atualizarPesquisaSatisfacao",
    ]),
    selecionaAnexo(e) {
      this.anexo = e;
    },
    salvar() {
      this.modalConfirmacao = false;
      this.showInputAnexo = false;

      if (this.$refs.formPesquisaSatisfacao.validate() == false) {
        return;
      }

      const form = new FormData();
      if (this.getPesquisaSatisfacao.venda_id) {
        form.append("venda_id", this.getPesquisaSatisfacao.venda_id);
      }

      if (this.getPesquisaSatisfacao.check_list_produtos) {
        for (
          let i = 0;
          i < this.getPesquisaSatisfacao.check_list_produtos.length;
          i++
        ) {
          form.append(
            "check_list_produtos[]",
            this.getPesquisaSatisfacao.check_list_produtos[i]
          );
        }
      }

      if (this.getPesquisaSatisfacao.avaliacao_atendimento) {
        form.append(
          "avaliacao_atendimento",
          this.getPesquisaSatisfacao.avaliacao_atendimento
        );
      }

      if (this.getPesquisaSatisfacao.avaliacao_caixa) {
        form.append(
          "avaliacao_caixa",
          this.getPesquisaSatisfacao.avaliacao_caixa
        );
      }

      if (this.getPesquisaSatisfacao.avaliacao_produtos) {
        form.append(
          "avaliacao_produtos",
          this.getPesquisaSatisfacao.avaliacao_produtos
        );
      }

      if (this.getPesquisaSatisfacao.avaliacao_servicos) {
        form.append(
          "avaliacao_servicos",
          this.getPesquisaSatisfacao.avaliacao_servicos
        );
      }

      if (this.getPesquisaSatisfacao.indicaria_servicos) {
        form.append(
          "indicaria_servicos",
          this.getPesquisaSatisfacao.indicaria_servicos
        );
      }

      if (this.getPesquisaSatisfacao.como_conheceu) {
        form.append(
          "como_conheceu",
          this.getPesquisaSatisfacao.como_conheceu
        );
      }

      if (this.getPesquisaSatisfacao.conhece_midias_sociais) {
        form.append(
          "conhece_midias_sociais",
          this.getPesquisaSatisfacao.conhece_midias_sociais
        );
      }

      if (this.getPesquisaSatisfacao.midia_mais_usada) {
        form.append(
          "midia_mais_usada",
          this.getPesquisaSatisfacao.midia_mais_usada
        );
      }

      if (this.anexo) {
        form.append("anexo", this.anexo);
      }

      if (this.getPesquisaSatisfacao.id) {
        form.append("_method", "PUT");
        form.append("id", this.getPesquisaSatisfacao.id);
        this.atualizarPesquisaSatisfacao(form);
      } else {
        // this.getPesquisaSatisfacao.venda_id = this.getVenda.id;
        form.append("venda_id", this.getVenda.id);
        this.salvarPesquisaSatisfacao(form);
      }
      this.$nextTick(() => {
        this.showInputAnexo = true;
      });
    },
  },
  created() {},
};
</script>